import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const PlaceLabel = ({
  x,
  y,
  data,
}: {
  x: number
  y: number
  data: MapLabelType
}) => {
  const { width } = useWindowSize()

  const offsetbase = width < 712 ? 9 : 14
  const { label, offset } = data
  let offs = [0, 0],
    lineoffs = [0, 4],
    anchor = 'center'
  if (offset) {
    if (offset.includes('top')) {
      offs[1] = -offsetbase * 2
      if (offset === 'top') offs[1] = -offsetbase * 3
      anchor = 'middle'
    }
    if (offset.includes('bottom')) {
      offs[1] = offsetbase * 3
      lineoffs[1] = -12
      anchor = 'middle'
    }
    if (offset.includes('left')) {
      offs[0] = -offsetbase
      anchor = 'end'
      if (!offset.includes('bottom') && !offset.includes('top')) {
        offs[0] = -offsetbase * 2
        offs[1] = -4
      }
    }
    if (offset.includes('right')) {
      offs[0] = offsetbase
      anchor = 'start'
      if (!offset.includes('bottom') && !offset.includes('top')) {
        offs[0] = offsetbase * 2
        offs[1] = -4
      }
    }
  }
  return (
    <PlaceLabelGroup transform={`translate(${x},${y})`}>
      <MarkerLine
        x1={0}
        x2={offs[0] + lineoffs[0]}
        y1={0}
        y2={offs[1] + lineoffs[1]}
        stroke={'#7D7D7D'}
        strokeWidth={1}
      />
      <Label transform={`translate(${offs[0]},${offs[1]})`}>
        <text className='bg' textAnchor={anchor}>
          {label}
        </text>
        <text textAnchor={anchor}>{label}</text>
      </Label>
    </PlaceLabelGroup>
  )
}
const MarkerLine = styled.line`
  stroke: var(--text-color);
`
const Label = styled.g``
const PlaceLabelGroup = styled.g`
  font-size: 15px;
  font-weight: 400;
  font-family: var(--font-sans-serif);
  fill: var(--text-color);
  circle {
    fill: #000;
    opacity: 0.6;
  }
  text.bg {
    stroke: var(--site-background);
    stroke-width: 3;
  }
`
